import { Component, h, Element, Prop } from "@stencil/core";
import { dataStore, DATA_STORE_KEY_LATEST_BOOKING_STEP } from "../../global/DataStore";
import {registerCssAsset} from "../../helpers/utils";
import { i18n } from '../../utils/I18n';
import { BookingStep } from "../nj-home/BookingStep";

type ClickHandler = (event: Event) => void;

const ITEM_COUNT = 7;

registerCssAsset('icon/icon-check.svg');

@Component({
  tag: "nj-breadcrumb",
  styleUrl: "nj-breadcrumb.scss",
  shadow: true
})
export class NjBreadcrumb {
    @Element() el: HTMLElement;

    @Prop() menuIndex: number;
    @Prop() canGoBack: boolean = true;

    getClassListForItem(breadcrumbIndex: number) {
        let classList = ["breadcrumb__item"];

        if (this.itemIsActive(breadcrumbIndex)) {
            classList = [...classList, "breadcrumb__item--active"];
        }

        if (this.itemIsCompleted(breadcrumbIndex)) {
            classList = [...classList, "breadcrumb__item--completed"];
        }

        return classList;
    }

    itemIsActive(breadcrumbIndex: number) {
        return this.menuIndex == breadcrumbIndex;
    }

    itemIsCompleted(breadcrumbIndex: number) {
        return breadcrumbIndex < this.menuIndex;
    }

    createListItem(breadcrumbIndex: number, menuName: string, menuPath: string, handleClick: ClickHandler | undefined) {
        if (this.itemIsCompleted(breadcrumbIndex) && this.canGoBack) {
            return (
                <a href={menuPath} onClick={event => { if (handleClick != null) { handleClick(event) } }}>
                    <div>
                        <span class="breadcrumb__item-counter" aria-hidden="true"></span>
                        <span class={this.getClassListForTextItem(breadcrumbIndex).join(" ")}>{menuName}</span>
                    </div>
                </a>
            )
        } else {
            return (
                <div>
                    <span class="breadcrumb__item-counter" aria-hidden="true"></span>
                    <span class={this.getClassListForTextItem(breadcrumbIndex).join(" ")}>{menuName}</span>
                </div>
            )
        }
    }

    getClassListForTextItem(breadcrumbIndex: number): Array<string> {
        let classList = ["breadcrumb__item-text"];

        if (this.itemIsActive(breadcrumbIndex)) {
            classList = [...classList, "breadcrumb__item-text--active"];
        } else if (this.isItemPrevious(breadcrumbIndex)) {
            classList = [...classList, "breadcrumb__item-text--previous"];
        } else if (this.isItemNext(breadcrumbIndex)) {
            classList = [...classList, "breadcrumb__item-text--next"];
        }
        return classList;
    }

    isItemPrevious(breadcrumbIndex: number): boolean {
        return breadcrumbIndex >= 0 && breadcrumbIndex === (this.menuIndex - 1);
    }

    isItemNext(breadcrumbIndex: number): boolean {
        return breadcrumbIndex < ITEM_COUNT && breadcrumbIndex === (this.menuIndex + 1);
    }

    render()  {
        return (
            <nav class="breadcrumb" aria-label={i18n.getMessage("breadcrumb.title", "Übersicht Buchungsprozess")}>
                <ol class="breadcrumb__list" aria-live="polite">
                    <li
                        class={this.getClassListForItem(0).join(" ")}
                        aria-current={this.itemIsActive(0) ? "step" : undefined}
                    >
                        {this.createListItem(
                            0,
                            i18n.getMessage("breadcrumb.connection", "Verbindung"),
                            "#/home",
                            () => { dataStore().setSessionData(DATA_STORE_KEY_LATEST_BOOKING_STEP, BookingStep.FROM_TO) }
                        )}
                    </li>
                    <li
                        class={this.getClassListForItem(1).join(" ")}
                        aria-current={this.itemIsActive(1) ? "step" : undefined}
                    >
                        {this.createListItem(
                            1,
                            i18n.getMessage("breadcrumb.reservation", "Reservierung"),
                            "#/reservierung",
                            undefined,
                        )}
                    </li>
                    <li
                        class={this.getClassListForItem(2).join(" ")}
                        aria-current={this.itemIsActive(2) ? "step" : undefined}
                    >
                        {this.createListItem(
                            2,
                            i18n.getMessage("breadcrumb.additionalConnections", "Anschlüsse"),
                            "#/additional-connections",
                            undefined,
                        )}
                    </li>
                    <li
                        class={this.getClassListForItem(3).join(" ")}
                        aria-current={this.itemIsActive(3) ? "step" : undefined}
                    >
                        {this.createListItem(
                            3,
                            i18n.getMessage("breadcrumb.passengers", "Reisende"),
                            "#/reisende",
                            undefined,
                        )}
                    </li>
                    <li
                        class={this.getClassListForItem(4).join(" ")}
                        aria-current={this.itemIsActive(4) ? "step" : undefined}
                    >
                        {this.createListItem(
                            4,
                            i18n.getMessage("breadcrumb.summary", "Zusammenfassung"),
                            "#/zusammenfassung",
                            undefined,
                        )}
                    </li>
                    <li
                        class={this.getClassListForItem(5).join(" ")}
                        aria-current={this.itemIsActive(5) ? "step" : undefined}
                    >
                        {this.createListItem(
                            5,
                            i18n.getMessage("breadcrumb.payment", "Zahlung"),
                            "#/zahlung",
                            undefined,
                        )}
                    </li>
                    <li
                        class={this.getClassListForItem(6).join(" ")}
                        aria-current={this.itemIsActive(6) ? "step" : undefined}
                    >
                        {this.createListItem(
                            6,
                            i18n.getMessage("breadcrumb.ticket", "Ticket"),
                            "#/ticket",
                            undefined,
                        )}
                    </li>
                </ol>
            </nav>
        )
    }
}
